import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import translations from "../i18n/translations";
import english01 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -01.png";
import english02 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -02.png";
import english03 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -03.png";
import english04 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -04.png";
import english05 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -05.png";
import english06 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -06.png";
import english07 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -07.png";
import english08 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -08.png";
import english09 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -09.png";
import english10 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -10.png";
import english11 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -11.png";
import english12 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -12.png";
import english17 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -17.png";
import english18 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -18.png";
import english19 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -19.png";
import english20 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -20.png";
import english21 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -21.png";
import english22 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -22.png";
import english23 from "../ImagenesIngles/ICONOS INGLÉS  MI SEGURO SOMIT -23.png";

const STORAGE_KEY = "miseguro.idioma";
export const IdiomaContext = createContext(null);
// These maps must survive language changes so Spanish can always be restored.
const originalText = new WeakMap();
const internallyWrittenText = new WeakMap();
const internallyWrittenAttributes = new WeakMap();
const originalImageSources = new WeakMap();
const internallyWrittenImageSources = new WeakMap();

const englishImagesBySource = [
  [/card-poliza/i, english17], [/card-asesor/i, english18],
  [/card-(digital|carnet)/i, english19], [/card-gestiones/i, english20],
  [/card-proveedores/i, english21], [/Asistencias\.png/i, english22],
  [/pagos(?:2|3)?\.(?:png|jpg)/i, english23]
];
const englishCategoryImages = [
  [/(hospitales de ciudad|hospitales ciudad de guatemala|city hospitals|hospitals in guatemala city)/i, english10],
  [/(hospitales regionales|hospitales departamentales|regional hospitals)/i, english11],
  [/(hospitales|hospitals)$/i, english01], [/(m[eé]dicos|doctors)$/i, english02],
  [/(procedimientos ambulatorios|outpatient procedures)/i, english03],
  [/(centros de diagn[oó]stico|diagnostic centers)/i, english04],
  [/(farmacias|pharmacies)/i, english05], [/(laboratorios|laboratories)/i, english06],
  [/(centros de im[aá]genes|imaging centers)/i, english07],
  [/(redes m[eé]dicas|medical networks)/i, english08], [/(dentistas|odont[oó]logos|dentists)/i, english09],
  [/(centros de atenci[oó]n integral|centros integrales|comprehensive care centers)/i, english12]
];

const getEnglishImage = (element, source) => {
  const bySource = englishImagesBySource.find(([pattern]) => pattern.test(source));
  if (bySource) return bySource[1];
  const label = `${element.getAttribute("alt") || ""} ${element.getAttribute("title") || ""}`;
  return englishCategoryImages.find(([pattern]) => pattern.test(label))?.[1];
};

const normalize = (value) => String(value || "")
  .trim()
  .replace(/\s+/g, " ")
  .toLocaleLowerCase("es")
  .replace(/ã³/g, "ó").replace(/ã¡/g, "á").replace(/ã©/g, "é")
  .replace(/ã­/g, "í").replace(/ãº/g, "ú").replace(/ã±/g, "ñ");

const entries = Object.entries(translations).sort((a, b) => b[0].length - a[0].length);

export function translateText(value, language) {
  if (language !== "en" || typeof value !== "string" || !value.trim()) return value;
  const leading = value.match(/^\s*/)[0];
  const trailing = value.match(/\s*$/)[0];
  const content = value.trim();
  const exact = translations[normalize(content)];
  if (exact) return `${leading}${exact}${trailing}`;

  let result = content;
  entries.forEach(([spanish, english]) => {
    if (spanish.length < 4) return;
    const escaped = spanish.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    result = result.replace(new RegExp(`(^|[^\\p{L}])${escaped}(?=$|[^\\p{L}])`, "giu"),
      (_, prefix) => `${prefix}${english}`);
  });
  return `${leading}${result}${trailing}`;
}

export function IdiomaProvider({ children }) {
  const [language, setLanguageState] = useState(() => localStorage.getItem(STORAGE_KEY) || "es");
  const setLanguage = useCallback((next) => {
    const safe = next === "en" ? "en" : "es";
    localStorage.setItem(STORAGE_KEY, safe);
    setLanguageState(safe);
  }, []);
  const t = useCallback((text) => translateText(text, language), [language]);

  useEffect(() => {
    document.documentElement.lang = language;
    const attributes = ["placeholder", "title", "aria-label", "alt"];
    const translateImage = (element) => {
      if (element.tagName !== "IMG") return;
      if (!originalImageSources.has(element)) originalImageSources.set(element, element.getAttribute("src") || "");
      const original = originalImageSources.get(element);
      const next = language === "en" ? (getEnglishImage(element, original) || original) : original;
      if (element.getAttribute("src") !== next) {
        internallyWrittenImageSources.set(element, next);
        element.setAttribute("src", next);
      }
    };
    const translateTextNode = (node) => {
      if (["SCRIPT", "STYLE", "NOSCRIPT"].includes(node.parentElement?.tagName)) return;
      if (!originalText.has(node)) originalText.set(node, node.nodeValue);
      const next = translateText(originalText.get(node), language);
      if (node.nodeValue !== next) {
        internallyWrittenText.set(node, next);
        node.nodeValue = next;
      }
    };
    const translateElement = (root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        translateTextNode(node);
      }
      const elements = root.nodeType === Node.ELEMENT_NODE ? [root, ...root.querySelectorAll("*")] : [];
      elements.forEach((element) => attributes.forEach((attribute) => {
        if (!element.hasAttribute(attribute)) return;
        const key = `data-i18n-${attribute}`;
        if (!element.hasAttribute(key)) element.setAttribute(key, element.getAttribute(attribute));
        const next = translateText(element.getAttribute(key), language);
        if (element.getAttribute(attribute) !== next) {
          const pending = internallyWrittenAttributes.get(element) || {};
          pending[attribute] = next;
          internallyWrittenAttributes.set(element, pending);
          element.setAttribute(attribute, next);
        }
      }));
      elements.forEach(translateImage);
    };

    const observer = new MutationObserver((mutations) => mutations.forEach((mutation) => {
      if (mutation.type === "characterData") {
        const node = mutation.target;
        if (internallyWrittenText.get(node) === node.nodeValue) {
          internallyWrittenText.delete(node);
          return;
        }
        // React and table libraries frequently reuse a text node. In that case
        // its newly written Spanish value becomes the new source to translate.
        originalText.set(node, node.nodeValue);
        translateTextNode(node);
        return;
      }
      if (mutation.type === "attributes") {
        const element = mutation.target;
        const attribute = mutation.attributeName;
        if (attribute === "src") {
          if (internallyWrittenImageSources.get(element) === element.getAttribute("src")) {
            internallyWrittenImageSources.delete(element);
            return;
          }
          originalImageSources.set(element, element.getAttribute("src") || "");
          translateImage(element);
          return;
        }
        const pending = internallyWrittenAttributes.get(element);
        if (pending?.[attribute] === element.getAttribute(attribute)) {
          delete pending[attribute];
          return;
        }
        const key = `data-i18n-${attribute}`;
        element.setAttribute(key, element.getAttribute(attribute) || "");
        const next = translateText(element.getAttribute(key), language);
        if (element.getAttribute(attribute) !== next) {
          const nextPending = pending || {};
          nextPending[attribute] = next;
          internallyWrittenAttributes.set(element, nextPending);
          element.setAttribute(attribute, next);
        }
        return;
      }
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) translateTextNode(node);
        else if (node.nodeType === Node.ELEMENT_NODE) translateElement(node);
      });
    }));
    observer.observe(document.body, {
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: [...attributes, "src"],
      subtree: true
    });
    translateElement(document.body);
    document.querySelectorAll("img").forEach(translateImage);
    return () => observer.disconnect();
  }, [language]);

  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t]);
  return <IdiomaContext.Provider value={value}>{children}</IdiomaContext.Provider>;
}

export function useIdioma() {
  const context = useContext(IdiomaContext);
  if (!context) throw new Error("useIdioma debe usarse dentro de IdiomaProvider");
  return context;
}
